import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { usePermissions } from '../hooks/usePermissions';
import { useWorkspaceStore } from '../stores/workspace.store';
import { Breadcrumb } from '../components/Breadcrumb';
import { CertificationManager } from './admin';

export const Route = createFileRoute('/w/$workspaceId/settings/certifications')({
  component: WorkspaceCertificationsPage,
});

function WorkspaceCertificationsPage() {
  const { workspaceId } = Route.useParams();
  const { hasPermission } = usePermissions();
  const setWorkspace = useWorkspaceStore((s) => s.setWorkspace);

  const { data: workspace } = useQuery({
    queryKey: ['workspaces', workspaceId],
    queryFn: async () => {
      const response = await api.get(`/workspaces/${workspaceId}`);
      return response.data.data;
    },
  });

  useEffect(() => {
    if (workspace?.id && workspace?.name && workspace?.slug) {
      setWorkspace({ id: workspace.id, name: workspace.name, slug: workspace.slug });
    }
  }, [workspace, setWorkspace]);

  if (!hasPermission('certifications.manage')) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-8">
        <p className="text-gray-600 dark:text-gray-400">Você não tem permissão para gerenciar certificações.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Breadcrumb
          items={[
            { label: workspace?.name || 'Workspace', to: '/w/$workspaceId/clients', params: { workspaceId } },
            { label: 'Configurações', to: '/w/$workspaceId/settings/members', params: { workspaceId } },
            { label: 'Certificações do Workspace' },
          ]}
        />

        <div className="mt-6">
          <CertificationManager apiBase="/certification/workspace" />
        </div>
      </div>
    </div>
  );
}
